function convertOffsetToTimes(offset,duration){return offset.map(function(o){return o*duration;});}export{convertOffsetToTimes};